import Vuex from 'vuex';
import axios from 'axios';
import config from '../config';
let locale = localStorage.getItem(process.env.VUE_APP_NAME + '_locale') === 'zh' ? 'zh-CN' : localStorage.getItem(process.env.VUE_APP_NAME + '_locale');
export default () => {
    return new Vuex.Store({
        state: {
            isPhone: false, 

            shareQrcode: '', //二维码链接
            years: [], //年级，组
            isShowYearsPopup: false, //显示年级选择
            yearsActiveIndex: null, //年级选择索引
            yearsCheckedIndex: null, //年级选中的索引
            yearPageActiveIndex: null, //年级弹窗进度123
            group: [], //选中的组

            isShowSelect: false, //显示结束感谢视频的菜单
            backgroundAudio: '', //左下角背景音乐
        },
        mutations: {
            // 设置页面配置 title & keywords & description & shareQrcode
            setConfig(state, data) { 
                document.querySelector('meta[name="keywords"]').setAttribute('content', data.keywords)
                document.querySelector('meta[name="description"]').setAttribute('content', data.description)
                if(data.title) document.title = data.title;
                state.shareQrcode = data.wechat;
                state.backgroundAudio = data.background_music;
            },
            // 数据初始化
            dataInit(state, data) {
                state.years = data.map(v => {
                    v.group.forEach(vl => {
                        // 添加isChecked
                        vl.isChecked = true;
                    })
                    return v;
                })
            },
            dataInit2(state, data) {
                state.years = data.map(v => {
                    v.group.forEach(vl => {
                        vl.list.forEach(vll => {
                            // 添加isChecked
                            vll.isChecked = true;
                        })
                    })
                    return v;
                })
            },
            // 设置选中的组
            setGroup(state, data) {
                state.group = data.map(v => {
                    v.panorama.forEach(val => {
                        val.markers.forEach(value => {
                            if (value.type == 1) {
                                value.html = `<img class="icon" src="${require('../assets/images/icon_marker_09.png')}"/><p class="text">${value.name}</p>`;
                                // value.size = { width: 58, height: 70 };
                                value.className = 'marker1';
                                value.position = { textureX: value.x, textureY: value.y };
                            }
                            if (value.type == 2) {
                                // value.image = require('../assets/images/icon_marker_0' + value.icon + '.gif');
                                value.html = `<img class="icon" src="${require('../assets/images/icon_marker_0' + value.icon + '.png')}"/>`;
                                // value.size = { width: 120, height: 60 };
                                value.className = 'marker2';
                                value.position = { textureX: value.x, textureY: value.y };
                            }
                        })
                    })
                    return v
                })
            },
            setGroup2(state, data) {
                let array = [];
                data.forEach(v => {
                    v.list.forEach((vl, i) => {
                        vl._index = i;
                        vl.className = v.name;
                        vl.en_className = v.en_name;
                        array.push(vl);
                    })
                })
                state.group = array;
                this.commit('setGroup', state.group);
            },
        },
        actions: {
            // 获取页面配置 title & keywords & description & shareQrcode
            getConfig(context, payload){
                axios.get(config.config, {
                    params: {
                        school: process.env.VUE_APP_NAME
                    }
                })
                .then(function (result) {
                    if (result.data.code == 100) {
                        context.commit('setConfig', result.data.data)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
            },
            // 获取首页数据
            getHomeData(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.homeVideo, {
                        params: {
                            school: process.env.VUE_APP_NAME,
                            lang: locale,
                        }
                    })
                    .then(function (res) {
                        if(res.data.code == 100){
                            resolve(res.data.data);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                })
            },
            // 获取总数据>导航
            getData(context, payload) {
                const apiPath = process.env.VUE_APP_IS_HIGH_SCHOOL == '0' ? config.data : config.data2;
                axios.get(apiPath, {
                    params: {
                        school: process.env.VUE_APP_NAME,
                        lang: locale,
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        if (process.env.VUE_APP_IS_HIGH_SCHOOL == '0') { 
                            context.commit('dataInit', result.data.data);
                        } else {
                            context.commit('dataInit2', result.data.data);
                        }
                    }
                }).catch(() => {
                    
                })
            },
            // 获取全景图数组
            getPanorama(context, payload) {
                return new Promise((resolve, reject) => {
                    const apiPath = process.env.VUE_APP_IS_HIGH_SCHOOL == '0' ? config.panorama : config.panorama2;
                    axios.get(apiPath, {
                        params: {
                            ...payload,
                            school: process.env.VUE_APP_NAME,
                            lang: locale,
                        }
                    }).then((result) => {
                        if (result.data.code == 100) {
                            if(process.env.VUE_APP_IS_HIGH_SCHOOL == '0'){
                                context.commit('setGroup', result.data.data);
                            }else{
                                context.commit('setGroup2', result.data.data);
                                // context.commit('setGroup', context.state.group);
                            }
                            resolve();
                        }
                    }).catch(() => {
                    })
                })
            },
        }
    })
}